__turbopack_context__.v({
  "buttonGlow": "WalletConnect-module__KkXLgq__buttonGlow",
  "buyButton": "WalletConnect-module__KkXLgq__buyButton",
  "buyButtonContainer": "WalletConnect-module__KkXLgq__buyButtonContainer",
  "greenGradient": "WalletConnect-module__KkXLgq__greenGradient",
  "helpContainer": "WalletConnect-module__KkXLgq__helpContainer",
  "helpText": "WalletConnect-module__KkXLgq__helpText",
  "step": "WalletConnect-module__KkXLgq__step",
  "stepContent": "WalletConnect-module__KkXLgq__stepContent",
  "stepNumber": "WalletConnect-module__KkXLgq__stepNumber",
  "stepTitle": "WalletConnect-module__KkXLgq__stepTitle",
  "stepsContainer": "WalletConnect-module__KkXLgq__stepsContainer",
  "subtlePulse": "WalletConnect-module__KkXLgq__subtlePulse",
  "tutorialLink": "WalletConnect-module__KkXLgq__tutorialLink",
  "walletConnect": "WalletConnect-module__KkXLgq__walletConnect",
  "walletConnectHeader": "WalletConnect-module__KkXLgq__walletConnectHeader",
  "walletConnectTitle": "WalletConnect-module__KkXLgq__walletConnectTitle",
});
